// extracted by mini-css-extract-plugin
export var card = "SliderFooter-module--card--30bae";
export var cardTitle = "SliderFooter-module--cardTitle--ec44e";
export var cardsWrapper = "SliderFooter-module--cardsWrapper--8f7b4";
export var counter = "SliderFooter-module--counter--79f83";
export var country = "SliderFooter-module--country--4f154";
export var countryWrapper = "SliderFooter-module--countryWrapper--9536e";
export var fadeInAnimation = "SliderFooter-module--fadeInAnimation--2b877";
export var flag = "SliderFooter-module--flag--9d1be";
export var infoWrapper = "SliderFooter-module--infoWrapper--ce6f1";
export var link = "SliderFooter-module--link--46d91";
export var logo = "SliderFooter-module--logo--30ee4";
export var logoWrapper = "SliderFooter-module--logoWrapper--529c2";
export var title = "SliderFooter-module--title--1d8b7";
export var titleWrapper = "SliderFooter-module--titleWrapper--77d59";